import { render, staticRenderFns } from "./FreightTableNewValidityRanges.vue?vue&type=template&id=4b708680&scoped=true"
import script from "./FreightTableNewValidityRanges.vue?vue&type=script&lang=js"
export * from "./FreightTableNewValidityRanges.vue?vue&type=script&lang=js"
import style0 from "./FreightTableNewValidityRanges.vue?vue&type=style&index=0&id=4b708680&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b708680",
  null
  
)

export default component.exports